<template>
  <!-- TODO fix adding fields to object by select  -->
  <div>
    <div v-if="$store.state.select && $store.state.select[name]" class="xs-font">
      <i>Location:</i>
      <b>{{ $store.state.select[name].parent }}</b>
      <button type="button" @click="
        $set(cvalue, 'data', 'p__' + $store.state.select[name].parent);
      $set(show, 'mode', 'input');
      $delete($store.state.select, name);
      updatevalue();
      ">
        Assign location
      </button>
      <i>Value:</i>
      <b>{{ $store.state.select[name].val }}</b>
      <button type="button" @click="
        $set(cvalue, 'data', $store.state.select[name].val);
      $set(show, 'mode', 'input');
      $delete($store.state.select, name);
      updatevalue();
      ">
        Assign value
      </button>
    </div>
    <div v-if="show.mode === 'json'">
      <code v-if="jsonerror" class="warn label xs-font">Data must be valid JSON</code>
      <!-- <input
        :class="jsonerror ? 'warn-text' : ''"
        type="text"
        v-if="cvalue.rawdata && cvalue.rawdata.length < 32"
        @input="
          validjson(cvalue.rawdata)
            ? ((cvalue.data = JSON.parse(cvalue.rawdata)), updatevalue())
            : null
        "
        v-model="cvalue.rawdata"
        placeholder="Valid JSON string"
      /> -->
      <textarea class="sm-font fill" :class="jsonerror ? 'warn-text' : ''" @input="
        validjson(cvalue.rawdata)
          ? ((cvalue.data = JSON.parse(cvalue.rawdata)), updatevalue())
          : null
        " id="test-data" v-model="cvalue.rawdata" placeholder="Valid JSON string"></textarea>
    </div>
    <div v-if="show.mode === 'input'">
      <!-- Multiselect option for input mode -->
      <div v-if="multiselect" class="container p4">
        <select multiple v-model="cvalue.data" @change="updatevalue()" class="container p4">
          <option v-for="option in options" :key="option.value" :value="option.value">
            {{ option.label }}
          </option>
        </select>
        <div v-if="cvalue.data && cvalue.data.length > 0" class="xs-font m4">
          Selected: {{ cvalue.data.join(', ') }}
        </div>
      </div>
      <!-- Regular input -->
      <div v-else>
        <state v-if="typeof cvalue.data === 'object'" :name="formname" list="true" editable="true"
          :statedata="cvalue.data" :parent="name || 'cvalue.data'" v-model="cvalue.data" :nesting="0" :value="value" />
        <div v-else>
          <input v-if="typeof cvalue.data === 'string' || typeof cvalue.data === 'number'" @input="updatevalue()" v-model="cvalue.data"
            :type="typeof cvalue.data === 'boolean' ? 'checkbox' : 'text'" />
        </div>
      </div>
    </div>
    <div v-if="show.mode === 'fn'">
      {{ cvalue.data }}
      <hooks @input="updatevalue()" v-model="cvalue.data" :name="name + 'input'" :item="cvalue.data || {}"
        :value="cvalue.data" />
      <div v-if="cvalue.data.fun">
        {{ $store.state.app.advanced.functions[$store.state.ref.functions[cvalue.data.fun] || cvalue.data.fun]?.name ||
          cvalue.data.fun}}
      </div>
      <!-- <button v-if="cvalue.data.fun" type="button" @click="run()">
        Assign return to input
      </button>
      <button v-if="cvalue.data.fun" type="button" @click="run(cvalue.data)">
        Assign function to input
      </button> -->
    </div>
    <div v-if="show.mode === 'state'">
      <state :name="formname" v-model="cvalue.data" parent="state" :select="name" @change="
        $set(cvalue, 'data', $store.state.select[name].val);
      $set(show, 'mode', 'input');
      $set(show, 'mode', 'state');
      " :nesting="0" :value="value" :statedata="$store.state" />
    </div>
    <row v-if="!stick || stick === 'false'">
      <select v-model="currentMode" @change="
          if (currentMode === 'fn' && currentValue !== 'object') {
        currentValue = {};
      }
        if (currentMode === 'json') {
          cvalue.rawdata = JSON.stringify(currentValue);
        }
        updatevalue();
        ">
        <option v-for="mode in [
          { icon: 'brackets-curly', name: 'json' },
          { icon: 'indent', name: 'input' },
          { icon: 'function', name: 'fn' },
          { icon: 'database', name: 'state' },
        ]" :key="mode.name" :value="mode.name">
          {{ mode.name }}
        </option>
      </select>
    </row>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
    },
    value: {
      type: [String, Object, Number, Boolean, Array, Function],
      default: ''
    },
    required: {
      type: Boolean,
      default: false,
    },
    stick: {
      // keeps view type
      type: [Boolean, String],
      default: false,
    },
    formname: { type: String },
    name: {
      type: String,
      default: "" + Date.now(),
    },
    view: {
      type: String,
      default: "input",
    },
    "max-length": {
      type: [String, Number],
    },
    options: {
      type: Array,
      default: () => []
    },
    multiselect: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      input: this.value || "",
      jsonerror: false,
      currentMode: this.view,
      currentValue: this.value
    };
  },
  computed: {
    cvalue() {
      // Initialize data based on multiselect
      let data = this.currentValue;
      if (this.multiselect && !Array.isArray(data)) {
        data = [];
      }
      return { data: data, rawdata: JSON.stringify(this.currentValue) };
    },
    show() {
      return { mode: this.currentMode };
    }
  },
  watch: {
    value(newVal) {
      this.currentValue = newVal;
    },
    view(newVal) {
      this.currentMode = newVal;
    }
  },
  methods: {
    run(fn) {
      // if the call has a function, set this.cvalue to the fn and load input mode, else run the fn already set in cvalue.data and set cvalue.data to return value.
      return fn
        ? (this.currentValue = fn,
          this.currentMode = "input",
          this.updatevalue())
        : this.$store.dispatch("run", this.cvalue.data).then((v) => {
          this.currentValue = v;
          this.currentMode = "input";
          return this.updatevalue();
        });
    },
    updatevalue: function () {
      // give's parent component the value at cvalue.data
      this.currentValue = this.cvalue.data;
      this.$emit("input", this.cvalue.data);
    },
    validjson(str) {
      try {
        JSON.parse(str);
        this.$set(this, "jsonerror", false);
        return true;
      } catch (e) {
        this.$set(this, "jsonerror", true);
        return false;
      }
    },
  },
};
</script>